// src/plugins/sentry-context.ts
import * as Sentry from '@sentry/vue';

type CurrentUser = {
  id: string;
  email?: string;
  username?: string;
};

type TenantContext = {
  id: string;
  slug?: string;
  name?: string;
};

export function setSentryUserContext(user?: CurrentUser | null) {
  if (!user) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.username,
  });
}

export function setSentryTenantContext(tenant?: TenantContext | null) {
  if (!tenant) {
    Sentry.setTag('tenant_id', '');
    Sentry.setContext('tenant', null);
    return;
  }

  Sentry.setTag('tenant_id', tenant.id);
  Sentry.setContext('tenant', {
    id: tenant.id,
    slug: tenant.slug,
    name: tenant.name,
  });
}

export function setSentryAppContext() {
  Sentry.setTag('app_name', 'flowpilot-front');
  Sentry.setTag('app_env', import.meta.env.VITE_APP_ENV || 'development');
}